export class DebugHelperUtil {
  static readonly DEBUG = false;

  static logIfDebug(prefix: string, args: unknown[]) {
    if (this.DEBUG) {
      console.debug('\x1B[32m' + prefix, ...args);
    }
  }
}
